<template>
  <hm-content title="">
    <div class="mb10 flex flex-between">
      <div>
        <el-button type="primary" class="mr10" size="small" @click="add"
          >创建复购提醒计划</el-button
        >
      </div>
      <div>
        <el-input
          clearable
          v-model.trim="searchCondition.planName"
          placeholder="请输入计划名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <!-- <el-select
          v-model="searchCondition.queryType"
          size="small"
          class="mr10"
          clearable
        >
          <el-option label="全部" value="all"></el-option>
        </el-select> -->
        <el-select
          v-model="searchCondition.planStatus"
          size="small"
          class="mr10"
          clearable
        >
          <el-option label="未开始" value="notStart"></el-option>
          <el-option label="进行中" value="running"></el-option>
          <el-option label="已结束" value="end"></el-option>
          <el-option label="异常暂停" value="errorStop"></el-option>
          <el-option label="暂停" value="stop"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div>
      <el-table
        stripe
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          type="index"
          label="序号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="planName"
          label="计划名称"
          width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="计划时间"
          width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.planStartDate }}至{{ scope.row.planEndDate }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="planDiagnosisStatus"
          label="计划诊断"
        >
          <template slot-scope="scope">
            <el-popover
              placement="right"
              trigger="click"
              content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
              @show="tipShow(scope.row)"
              @after-leave="tipGoods = []"
              :disabled="scope.row.planDiagnosisStatus !== 'suggestOptimize'"
            >
              <div>
                <div class="mb10" style="font-weight: bold; font-size: 16px">
                  该提醒计划建议优化
                </div>
                <div v-if="tipGoods.length">
                  <div v-for="(v, i) in tipGoods" :key="i">
                    <span class="gray mr10">
                      {{ v.spuName }} {{ v.specIdGroupName }}</span
                    >
                    <span class="orange"
                      >最近{{ configModel.daysAfterPlan }}天转化率低于{{
                        configModel.minValue
                      }}%</span
                    >
                  </div>
                </div>

                <div v-else class="gray">暂无待优化商品</div>
                <div class="orange mt10">* 优化后次日查看效果</div>
                <div class="mt10">
                  <el-button
                    size="small"
                    type="primary"
                    @click="edit(scope.row)"
                    >现在去优化</el-button
                  >
                </div>
              </div>
              <template slot="reference">
                <span
                  v-if="scope.row.planDiagnosisStatus === 'normal'"
                  class="success"
                  >表现良好
                  <span
                    style="font-size: 15px; margin-left: 5px"
                    class="el-icon-circle-check"
                  ></span>
                </span>
                <span
                  class="danger pointer"
                  v-else-if="
                    scope.row.planDiagnosisStatus === 'suggestOptimize'
                  "
                >
                  建议优化<span
                    style="font-size: 15px; margin-left: 5px"
                    class="el-icon-warning-outline"
                  ></span>
                </span>
                <span v-else class="gray">
                  数据不足
                    <!-- {{ scope.row.planDiagnosisStatus }} -->
                </span>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalNoticeNum"
          label="通知人数"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalVisitNum"
          label="访问人数"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="下单转化率"
          prop="proportion"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="状态"
          prop="planStatus"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.planStatus === 'notStart'" class="gray">
              未开始
            </div>
            <div v-else-if="scope.row.planStatus === 'running'" class="success">
              进行中
            </div>
            <div v-else-if="scope.row.planStatus === 'end'" class="gray">
              已结束
            </div>
            <div
              v-else-if="scope.row.planStatus === 'errorStop'"
              class="danger"
            >
              异常暂停
            </div>
            <div v-else-if="scope.row.planStatus === 'stop'" class="orange">
              暂停
            </div>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <el-button
              size="small"
              class="blue"
              type="text"
              @click="details(scope.row)"
              >数据</el-button
            >
            <el-divider direction="vertical"></el-divider>
            <el-button
              size="small"
              class="blue"
              type="text"
              @click="edit(scope.row)"
              >编辑</el-button
            >
            <el-divider direction="vertical"></el-divider>
            <el-button
              @click="operate(scope.row)"
              v-if="
                scope.row.planStatus === 'notStart' ||
                scope.row.planStatus === 'end'
              "
              size="small"
              type="text"
              class="gray"
              :disabled="
                scope.row.planStatus === 'notStart' ||
                scope.row.planStatus === 'end'
              "
              >{{
                scope.row.planStatus === "errorStop" ||
                scope.row.planStatus === "stop"
                  ? "开启"
                  : "暂停"
              }}</el-button
            >
            <el-button
              @click="operate(scope.row)"
              v-else
              size="small"
              type="text"
              :class="
                scope.row.planStatus === 'errorStop' ||
                scope.row.planStatus === 'stop'
                  ? 'success'
                  : 'orange'
              "
              >{{
                scope.row.planStatus === "errorStop" ||
                scope.row.planStatus === "stop"
                  ? "开启"
                  : "暂停"
              }}</el-button
            >
            <el-divider direction="vertical"></el-divider>
            <el-button
              size="small"
              class="danger"
              type="text"
              @click="del(scope.row)"
              >删除</el-button
            >
            <el-divider direction="vertical"></el-divider>
            <el-button
                size="small"
                class="blue"
                type="text"
                @click="copy(scope.row)"
            >复制</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      tipGoods: [],
      configModel: {},
      total: 0,
      list: [],
      pageSize: 10,
      currentPage: 1,
      searchCondition: {}
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async tipShow(row) {
      const { code, result } = await this.$store.dispatch(
        "querySuggestOptimizeSkuList",
        row
      );

      if (code === "0") {
        this.tipGoods = result.planSkuRelModels;
        this.configModel = result.configModel;
      }
    },
    copy(row) {
      this.$router.push({
        name: "CreatetPurchasePlan",
        query: {
          type: "copy",
          id: row.id
        }
      });
    },
    edit(row) {
      this.$router.push({
        name: "CreatetPurchasePlan",
        query: {
          type: "edit",
          id: row.id
        }
      });
    },
    operate(row) {
      let params = {
        id: row.id,
        operateType: "enabledState",
        enabledState:
          row.planStatus === "errorStop" || row.planStatus === "stop"
            ? "yes"
            : "no"
      };

      this.$store.dispatch("operateStoreRepurchasePlan", params).then(res => {
        if (res.code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryList();
        }
      });
    },
    details(row) {
      this.$router.push({
        name: "ScheduleMessageStatistics",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    del(row) {
      this.$confirm("是否确认删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        row.operateType = "del";
        this.$store.dispatch("operateStoreRepurchasePlan", row).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    add() {
      this.$router.push({
        name: "CreatetPurchasePlan"
      });
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryStoreRepurchasePlanInfoList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        records.forEach(v => {
          v.proportion = v.totalNoticeNum
            ? ((v.totalPayNum / v.totalNoticeNum) * 100).toFixed(2) + "%"
            : "0%";
        });
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang='scss' scoped>
</style>
